import { DnaIcon, FingerprintIcon, FlaskConicalIcon, MicroscopeIcon, MonitorSmartphoneIcon, ScanSearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Fondamenti di Scienze Forensi',
    summary: "Che cos'è la scienza forense, il metodo scientifico applicato alle prove, osservazione e interpretazione, tipi di prove, integrità e catena di custodia, come lavora un laboratorio.",
    icon: MicroscopeIcon,
  },
  {
    number: '2',
    title: 'Scena del Crimine e Raccolta delle Prove',
    summary: "Che cos'è una scena, sicurezza e perimetro, metodi di ricerca, fotografia e schizzi, raccolta, confezionamento e catena di custodia.",
    icon: ScanSearchIcon,
  },
  {
    number: '3',
    title: 'Impronte Digitali, Segni e Tracce',
    summary: 'Impronte digitali e loro classificazione, rilevamento e confronto, impronte di scarpe e attrezzi, fibre, capelli, vetro, terra e microtracce.',
    icon: FingerprintIcon,
  },
  {
    number: '4',
    title: 'Biologia Forense, DNA, Patologia e Antropologia',
    summary: 'Prove biologiche, test presuntivi e di conferma, DNA e profilo genetico, interpretazione e probabilità, basi di patologia e antropologia forense, etica.',
    icon: DnaIcon,
  },
  {
    number: '5',
    title: 'Chimica Forense e Tossicologia',
    summary: 'Sostanze sconosciute, screening e conferma, cromatografia e spettrometria, analisi qualitativa e quantitativa, tossicologia, controlli e affidabilità dei risultati.',
    icon: FlaskConicalIcon,
  },
  {
    number: '6',
    title: 'Informatica Forense e Ricostruzione del Caso',
    summary: 'Prove digitali, acquisizione e valore di hash, metadati, telefoni e rete, linee del tempo e integrazione di tutte le prove in una ricostruzione prudente.',
    icon: MonitorSmartphoneIcon,
  },
];
